export const manufactures_index = ['manufactures.index']
export const manufactures_create = ['manufactures.create']
export const manufactures_edit = ['manufactures.edit']

export default [].concat(
    manufactures_index,
    manufactures_create,
    manufactures_edit
)
